import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors } from '@/styles'
import { InputClear } from '@/components/icons'
import { Tooltip } from '@/components/tooltip'

const ClearButtonWrapper = styled.div`
  position: absolute;
  top: 14px;
  right: 28px;
`
const Button = styled.div`
  border-radius: 20px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.grey88};
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;
  :hover {
    opacity: 0.7;
  }
`
const ClearButton = ({ onClick = () => {} }) => {
  const { t } = useTranslation()
  return (
    <ClearButtonWrapper>
      <Tooltip
        text={t('b.listing.view.clear_address_input.tooltip', 'Clear Address')}
        position="top"
      >
        <Button onClick={onClick}>
          <InputClear width={17} height={17} />
        </Button>
      </Tooltip>
    </ClearButtonWrapper>
  )
}

export default ClearButton
